export type TourRect = { left: number; top: number; width: number; height: number }
export type TourSide = 'top' | 'bottom' | 'left' | 'right'
const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max))

export function placeTour(target: TourRect | null, viewport: TourRect, cardHeight: number) {
  const margin = 12, gap = 16
  const width = Math.min(356, viewport.width - margin * 2)
  const bounds = { left: viewport.left + margin, top: viewport.top + margin,
    right: viewport.left + viewport.width - margin, bottom: viewport.top + viewport.height - margin }
  const centered = { left: bounds.left + (viewport.width - margin * 2 - width) / 2,
    top: bounds.top + Math.max(0, (viewport.height - margin * 2 - cardHeight) / 2), width,
    maxHeight: viewport.height - margin * 2, availableHeight: viewport.height - margin * 2,
    side: 'bottom' as TourSide, arrow: null }
  if (!target) return centered
  const right = target.left + target.width, bottom = target.top + target.height
  const spaces = { bottom: bounds.bottom - bottom - gap, top: target.top - gap - bounds.top,
    right: bounds.right - right - gap, left: target.left - gap - bounds.left }
  const vertical = spaces.bottom >= cardHeight ? 'bottom' : spaces.top >= cardHeight ? 'top' : null
  const side: TourSide = vertical || (spaces.right >= width ? 'right' : spaces.left >= width ? 'left' :
    spaces.bottom >= spaces.top ? 'bottom' : 'top')
  const maxHeight = Math.max(0, side === 'top' || side === 'bottom' ? spaces[side] : bounds.bottom - bounds.top)
  // A resized writing field can fill a short landscape screen. Keep the guide
  // readable and its controls reachable even when there is no room beside it.
  if (maxHeight < Math.min(164, cardHeight)) return { ...centered, side, availableHeight: maxHeight }
  const height = Math.min(cardHeight, maxHeight)
  const left = side === 'right' ? right + gap : side === 'left' ? target.left - gap - width :
    clamp(target.left + target.width / 2 - width / 2, bounds.left, bounds.right - width)
  const top = side === 'bottom' ? bottom + gap : side === 'top' ? target.top - gap - height :
    clamp(target.top + target.height / 2 - height / 2, bounds.top, bounds.bottom - height)
  return { left: clamp(left, bounds.left, bounds.right - width),
    top: clamp(top, bounds.top, bounds.bottom - height), width, maxHeight, availableHeight: maxHeight, side,
    arrow: side === 'top' || side === 'bottom' ? clamp(target.left + target.width / 2 - left, 20, width - 20) :
      clamp(target.top + target.height / 2 - top, 20, height - 20) }
}
